module.exports = __webpack_public_path__ + "img/4_en.84f04d18.png";